export default __webpack_public_path__ + "dd0a3d5fccc9a531633c050d0a2abde8.png";